import { html } from "htm/preact";
import { TERMS } from "../copy.js";

/**
 * The way out of a game screen this device can't open.
 *
 * Every screen inside a tournament reads its data through `getClient(code)`, which
 * returns null when there is no stored token — and a null client never produces a
 * snapshot, so a screen that only checks for the snapshot waits for one that is never
 * coming. That is a dead end, not a load: no message, no link, and the tab bar's own
 * buttons lead straight back to it.
 *
 * It isn't only the obvious case of following someone else's link, either. Stored
 * access expires after fourteen days (`AUTH_TTL_MS`) while a tournament itself lives
 * for sixty, so a game you joined and left alone for a fortnight ends up here on its
 * own — off the home screen, which still lists it.
 */
export function NotJoined({ code }: { code: string }) {
  return html`
    <div class="card">
      <p>${`This device isn't signed in to ${TERMS.event} ${code} — either it hasn't joined, or its access has expired.`}</p>
      <p class="field-help mb-0">
        <a href=${`#/join/${code}`}>Join with code ${code}</a> · <a href="#/">Home</a>
      </p>
      <p class="field-help mb-0">
        Not playing in this one? The same screen has a way to watch without taking a
        name.
      </p>
    </div>
  `;
}
